import type { FC } from 'react';

import Flex from '../../Flex';
import { Actions } from '../styles';

const ModalActions: FC = ({ children }) => (
    <Actions>
        <Flex justify="flex-end" gap={2}>
            {children}
        </Flex>
    </Actions>
);

export default ModalActions;
